module.exports = "<div class=\"progress\">\r\n  <div\r\n    class=\"progress-bar progress-bar-striped bg-success progress-bar-animated\"\r\n    [style.width]=\"progress + '%'\">\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/+admin/modules/cb-progress/cb-progress.component.html
// module id = 479
// module chunks = 6 7 8 12 13 14 15 16 17 19